/* src/app/ship/ship-to/ship-to.component.scss */
.ship-to {
  width: 100%;
}
.ship-to .form-section-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.ship-to .form-section-header .form-section-actions {
  margin: 0;
}
.ship-to .select-wrapper {
  position: relative;
}
/*# sourceMappingURL=ship-to.component.css.map */
